var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-table board-table--view mb-12",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("[" + _vm._s(_vm.category) + "] " + _vm._s(_vm.program.title))]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": "",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        _vm.showContent = !_vm.showContent;
      }
    }
  }, [_vm._v(_vm._s(_vm.showContent ? "닫기" : "상세보기"))])], 1)], 1)], 1)]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('ul', {
    staticClass: "board-view-data"
  }, [_c('li', [_vm._v(" 신청기간 : "), _c('span', {
    staticClass: "d-inline-block"
  }, [_vm._v(_vm._s(_vm.applicationDuration))])]), _c('li', [_vm._v(" 지원기간 : "), _c('span', {
    staticClass: "d-inline-block"
  }, [_vm._v(_vm._s(_vm.serviceDuration))])])])])]), _vm.showContent ? _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('div', {
    staticClass: "board-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.program.content)
    }
  })])])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }